// extracted by mini-css-extract-plugin
export var arrows = "_m-6";
export var decrementer = "_m-a";
export var disabled = "_m-4";
export var error = "_m-1";
export var hiddenText = "_m-b";
export var incrementer = "_m-9";
export var input = "_m-8";
export var inputWrapper = "_m-0";
export var leadingIcon = "_m-c";
export var readonly = "_m-3";
export var regular = "_m-7";
export var small = "_m-5";
export var warning = "_m-2";